// OffersList.styles
import styled from 'styled-components';
import { COLORS } from '../../styles/variables';
import { device } from '../../styles/devices';
import { AlphaTheme } from '../../../design-system/ThemeProvider/alphaTheme';

export const OffersListWrapper = styled.section<{ isEmptyState: boolean }>`
  background-color: ${({ theme }: { theme: Partial<AlphaTheme> }) =>
    theme.canvas200 ?? COLORS.grey5};
  flex: 1;
  min-height: ${({ isEmptyState }) => (isEmptyState ? '100dvh' : 'auto')};
  width: 100%;
  @media ${device.laptop} {
    height: unset;
    overflow-y: unset;
    // THIS IS IMPORTANT FOR FEATURED OFFERS SECTION
    width: 100%;
    overflow-x: hidden;
  }

  .embla-alpha {
    width: auto;
    margin: 0 0 0 var(--Sys-PageMargin, 16px);

    @media (min-width: 768px) {
      margin: 0 0 0 var(--Sys-PageMargin, 40px);
    }

    @media (min-width: 1024px) {
      margin: 0 0 0 var(--Sys-Space-Relative-2XL, 40px);
    }

    @media (min-width: 1440px) {
      margin: 0 0 0 var(--Sys-Space-Relative-2XL, 56px);
    }

    &--filters-closed {
      margin: 0 0 0 var(--Sys-PageMargin-XS, 16px);
      @media (min-width: 768px) {
        margin: 0 0 0 var(--Sys-PageMargin-MD, 40px);
      }
      @media (min-width: 1024px) {
        margin: 0 0 0 var(--Sys-PageMargin, 60px);
      }
      @media (min-width: 1440px) {
        margin: 0 0 0 var(--Sys-PageMargin, 96px);
      }
    }
  }
`;

export const GeneralSidePadding = styled.div<{ isFiltersOpen: boolean }>`
  padding-right: 16px;
  padding-left: 16px;
  @media ${device.mobileL} {
    padding-right: 40px;
    padding-left: 40px;
  }
  @media ${device.laptopMd} {
    padding: ${({ isFiltersOpen }) => (isFiltersOpen ? '0 98px 0 40px' : '0 96px 0 96px')};
  }

  &.alpha-header {
    margin: 0 var(--Sys-PageMargin-XS, 16px);
    padding: 0;

    @media (min-width: 768px) {
      margin: 0 var(--Sys-PageMargin-MD, 40px);
    }

    @media (min-width: 1024px) {
      margin: ${({ isFiltersOpen }) => (isFiltersOpen ? `0 var(--Sys-PageMargin-MD, 40px)` : `0 var(--Sys-PageMargin, 60px)`)};
    }

    @media (min-width: 1440px) {
      margin: ${({ isFiltersOpen }) => (isFiltersOpen ? `0 var(--Sys-Space-Relative-2XL, 56px)` : `0 var(--Sys-PageMargin, 96px)`)};
    }

    &.filters-selected--total-results {
      section {
        padding: 0 0 var(--Sys-Space-Relative-3XL, 72px);
      }
    }

    @media (min-width: 1440px) {
      .filters-selected--results {
        .results-wrapper {
          padding-top: var(--Sys-Space-Fixed-600, 48px);
        }
      }
    }
  }
`;

export const SkipToSection = styled.section``;
export const FeaturedOfferSection = styled.section`
  /* width: 60%;
  align-self: flex-end; */
`;
export const OffersListSection = styled.section``;
